var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.27L17.17 20.39C17.55 20.62 18.02 20.28 17.92 19.85L16.55 13.97L21.11 10.02C21.44 9.73 21.27 9.18 20.82 9.14L14.81 8.63L12.46 3.09C12.29 2.68 11.71 2.68 11.54 3.09L9.18999 8.63L3.17999 9.14C2.73999 9.18 2.55999 9.73 2.89999 10.02L7.45999 13.97L6.08999 19.85C5.98999 20.28 6.45999 20.62 6.83999 20.39L12 17.27Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStarFill);
export default __webpack_public_path__ + "static/media/ico-star-fill.9fd4eca1b97ceb95fd6f13d684f9e2ea.svg";
export { ForwardRef as ReactComponent };